import { Transforms } from 'slate';
import type { SlateEditor, TElement } from 'platejs';
import { insertImage } from '@platejs/media';

import { asEditor } from 'common/components/ContentEditor/utils/editorHelpers';
import { options } from 'common/components/ContentEditor/options';

export const addOrReplaceImage = (editor: SlateEditor, url: string) => {
    const fileNode = editor.api.block({
        match: { type: options.img.type },
    });

    if (fileNode) {
        Transforms.setNodes(asEditor(editor), { url } as Partial<TElement>, {
            at: fileNode[1],
        });

        return;
    }

    insertImage(editor, url);
};
